import React, { Component } from 'react';
import { loadData } from './card-data.service';
import CardEntry from './card.component';
import { Typography, Grid } from '@material-ui/core';

class CardContainerComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'Must Watch Movies & TV Shows',
      updated: 'n/a',
      entries: []
    }
  }

  componentDidMount() {
    loadData().then(({ entries, updated }) => {
      this.setState({ entries, updated })
    })
  }

  render() {
    const { title, entries, updated } = this.state;
    // const cardList = ;
    return <div style={{ marginTop: 20, padding: 30 }}>
      <Typography variant="h2" component="h1">{title}</Typography>
      <p><small>Last updated - {updated}</small></p>
      <Grid container spacing={2}>
        {
          entries.map(e => (
            <Grid item key={e.id} xs={12} sm={3}>
              <CardEntry {...e}></CardEntry>
            </Grid>
          ))
        }
      </Grid>
      <Typography variant='caption' component="p" style={{ marginTop: 15 }}>
        That's it for now! Images from <a href="https://unsplash.com/" target="_blank">Unsplash</a>
      </Typography>
    </div>
  }
}
export default CardContainerComponent;